/**
 * EasyGo Pet Carrier 产品图片切换系统
 * 根据三个属性(Handle Color, Body Color, Strap Color)动态切换产品图片
 */

(function() {
  'use strict';

  console.log('🔧 [EasyGo] 脚本开始加载...');

  // ========== 配置 ==========
  // 支持多个产品名称变体
  const PRODUCT_NAMES = [
    'EasyGo Pet Carrier',
    'EasyGo Pet Carrier (without Collar)',
    'EasyGo Pet Carrier (WITHOUT Collar)'
  ];
  const CDN_BASE_URL = 'https://cdn.shopify.com/s/files/1/0875/0733/7463/files/';
  const CDN_VERSION = '?v=1763954811';

  // 🎯 强制从 CDN 加载的组合（Body Color + Strap Color）
  // 这些组合的图片在 CDN 上，不在 variant 中
  const FORCE_CDN_COMBINATIONS = [
    { body: 'pink', strap: 'white' },  // 粉色包 + 白色绳子
    { body: 'blue', strap: 'white' },  // 蓝色包 + 白色绳子
    { body: 'brown', strap: 'white' }  // 棕色包 + 白色绳子
  ];
  
  // 🎯 已上传到 CDN 的图片（Pink/Blue/Brown Body + White Strap 组合）
  const AVAILABLE_CDN_IMAGES = [
    // Pink Body + White Strap
    'babyblue_pink_white',
    'babypink_pink_white',
    'blue_pink_white',
    'cyan_pink_white',
    'navyblue_pink_white', // 新增 Navy Blue
    'pink_pink_white',
    'purple_pink_white',
    'white_pink_white',
    'yellow_pink_white',
    
    // Blue Body + White Strap
    'babyblue_blue_white',
    'babypink_blue_white',
    'cyan_blue_white',
    'navyblue__blue_white', // 注意：截图显示有两个下划线
    'pink_blue_white',
    'purple_blue_white',
    'white_blue_white',
    'yellow_blue_white',
    
    // Brown Body + White Strap
    'babyblue_brown_white',
    'babypink_brown_white',
    'cyan_brown_white',
    'navyblue_brown_white',
    'pink_brown_white',
    'purple_brown_white',
    'white_brown_white',
    'yellow_brown_white'
  ];

  // 颜色名称映射(产品选项名称 -> 文件名)
  const COLOR_NAME_MAP = {
    // Handle Colors
    'BabyBlue': 'babyblue',
    'Baby Blue': 'babyblue',
    'BabyPink': 'babypink',
    'Baby Pink': 'babypink',
    'Blue': 'blue',
    'Cyan': 'cyan',
    'Pink': 'pink',
    'Purple': 'purple',
    'White': 'white',
    'Yellow': 'yellow',
    'AccoYellow': 'yellow',
    'Orange': 'orange',
    'Black': 'black',
    'Green': 'green',
    'Red': 'red',
    'Brown': 'brown',
    'NavyBlue': 'navyblue',
    'Navy Blue': 'navyblue'
  };

  // 颜色代码映射(用于显示颜色球)
  const COLOR_CODE_MAP = {
    'BabyBlue': '#A7C6ED',
    'BabyPink': '#FFB6D9',
    'Blue': '#2A6EBB',
    'Cyan': '#00CED1',
    'Pink': '#EEC3D7',
    'Purple': '#9B59B6',
    'White': '#FFFFFF',
    'Yellow': '#FFD93D',
    'Orange': '#E49B2A',
    'Black': '#000000',
    'Green': '#27AE60',
    'Red': '#E03C31',
    'Brown': '#8B5B29',
    'NavyBlue': '#001F3F'
  };

  // ========== 工具函数 ==========
  
  // 检测是否在 customize 构建器页面
  function isCustomizePage() {
    return document.querySelector('.custom-builder') !== null;
  }

  // 检查是否应该运行(只对 EasyGo Pet Carrier 启用)
  // 使用静态变量记录是否已经输出过不匹配日志，避免重复输出
  let hasLoggedMismatch = false;
  let lastCheckedProduct = '';
  
  function shouldRun() {
    // 排除 Valentine 产品
    const path = window.location.pathname.toLowerCase();
    const pageTitle = document.title.toLowerCase();
    if (/valentine|情人节/.test(path + ' ' + pageTitle)) {
      return false;
    }

    // 目标产品的 handle 列表（含 SEO 改动后的 handle）
    const TARGET_HANDLES = ['easygo-pet-carrier', 'pet-carrier-easygo', 'easygo', 'custom-pet-carrier'];

    // Customize 页面
    if (isCustomizePage()) {
      const productSelect = document.getElementById('product-select');
      if (productSelect && productSelect.options.length > 0) {
        const selectedOption = productSelect.options[productSelect.selectedIndex];
        if (selectedOption) {
          const selectedName = selectedOption.textContent.trim();
          const selectedHandle = selectedOption.value; // 获取 handle

          // 检查名称或 handle 是否匹配
          // 🎯 使用多个产品名称匹配，或使用 includes 匹配
          const nameMatch = PRODUCT_NAMES.some(name => selectedName === name) || 
                           (selectedName.includes('EasyGo') && selectedName.includes('Carrier') && !selectedName.includes('Outdoor')) ||
                           (selectedName.includes('Customizable') && selectedName.includes('Pet Carrier')) ||
                           (selectedName.includes('Custom') && selectedName.includes('Pet Carrier'));
          const handleMatch = TARGET_HANDLES.some(h => selectedHandle.includes(h));

          if (nameMatch || handleMatch) {
            console.log('✅ [EasyGo] Customize页面匹配:', selectedName, '| Handle:', selectedHandle);
            hasLoggedMismatch = false; // 重置标记
            lastCheckedProduct = selectedName;
            return true;
          } else {
            // 🎯 只在产品切换时或第一次检查时输出日志，避免重复
            if (!hasLoggedMismatch || lastCheckedProduct !== selectedName) {
              console.log('⏭️  [EasyGo] Customize页面产品不匹配:', selectedName);
              hasLoggedMismatch = true;
              lastCheckedProduct = selectedName;
            }
          }
        }
      }
      return false;
    }

    // 普通产品页面:只检查 URL（更严格的检查）
    const url = window.location.href.toLowerCase();

    // 🎯 排除 AccoGift EasyGo Pet Outdoor Set / Pet Travel Gift Set（由 product-easygo-outdoor-set.js 处理）
    if ((url.includes('accogift') && (url.includes('outdoor-set') || url.includes('outdoor set'))) ||
        (pageTitle.includes('accogift') && (pageTitle.includes('outdoor set') || pageTitle.includes('outdoor-set')))) {
      console.log('⏭️  [EasyGo] 跳过 AccoGift EasyGo Pet Outdoor Set（由其他脚本处理）');
      return false;
    }
    if (url.includes('pet-travel-gift-set') || pageTitle.includes('pet travel gift set')) {
      console.log('⏭️  [EasyGo] 跳过 Pet Travel Gift Set（由 outdoor-set 脚本处理）');
      return false;
    }

    // 只有当 URL 或标题中明确包含 easygo 且不是 Outdoor Set 才运行
    const hasEasyGo = (url.includes('easygo') || pageTitle.includes('easygo')) && 
                      !url.includes('outdoor-set') && 
                      !pageTitle.includes('outdoor set');
    
    if (hasEasyGo) {
      console.log('✅ [EasyGo] 产品页面匹配 (URL/标题包含 easygo)');
      return true;
    }

    // 如果URL中包含产品的handle，也可以匹配（含 SEO 后的 custom-pet-carrier）
    const productHandles = ['easygo-pet-carrier', 'pet-carrier-easygo', 'custom-pet-carrier'];
    const hasHandle = productHandles.some(handle => url.includes(handle));
    
    if (hasHandle) {
      console.log('✅ [EasyGo] 产品页面匹配 (URL包含产品handle)');
      return true;
    }

    return false;
  }

  // 标准化颜色名称(转换为文件名格式)
  function normalizeColorName(colorName) {
    if (!colorName) return null;

    // 先查找映射表
    if (COLOR_NAME_MAP[colorName]) {
      return COLOR_NAME_MAP[colorName];
    }

    // 清理并转小写
    const normalized = colorName
      .toLowerCase()
      .replace(/\s+/g, '')
      .replace(/[^a-z]/g, '');

    // 再次查找映射表(使用清理后的名称)
    const keys = Object.keys(COLOR_NAME_MAP);
    for (const key of keys) {
      const keyNormalized = key.toLowerCase().replace(/\s+/g, '');
      if (keyNormalized === normalized) {
        return COLOR_NAME_MAP[key];
      }
    }

    console.warn('⚠️  [EasyGo] 未找到颜色映射:', colorName);
    return normalized;
  }

  // 生成图片 URL
  function generateImageUrl(handleColor, bodyColor, strapColor) {
    const handle = normalizeColorName(handleColor);
    const body = normalizeColorName(bodyColor);
    const strap = normalizeColorName(strapColor);

    if (!handle || !body || !strap) {
      console.warn('⚠️  [EasyGo] 颜色值不完整:', { handleColor, bodyColor, strapColor });
      return null;
    }

    const filenameBase = `${handle}_${body}_${strap}`;
    
    // 🎯 验证这个组合是否在已上传的 CDN 图片列表中
    let finalFilename = filenameBase;
    if (!AVAILABLE_CDN_IMAGES.includes(filenameBase)) {
      // 尝试查找可能的替代命名（比如 navyblue__blue_white）
      const alternativeName = `${handle}__${body}_${strap}`;
      if (AVAILABLE_CDN_IMAGES.includes(alternativeName)) {
        console.log(`🔧 [EasyGo] 找到替代文件名: ${alternativeName}`);
        finalFilename = alternativeName;
      } else {
        console.error('❌ [EasyGo] 该颜色组合的图片未上传到 CDN:', filenameBase);
        console.log('📋 [EasyGo] 可用的 CDN 图片:', AVAILABLE_CDN_IMAGES);
        return null;
      }
    }
    
    const filename = `${finalFilename}.png`;
    const url = `${CDN_BASE_URL}${filename}${CDN_VERSION}`;

    console.log('🔧 [EasyGo] 生成图片URL:', url);
    return url;
  }

  // ========== 主要功能 ==========

  // 防抖计时器
  let updateTimer = null;
  // 👀 新增：监听主图容器的 observer
  let galleryObserver = null;

  // 获取当前选中的颜色(根据选项索引)
  function getCurrentColor(optionIndex) {
    // Customize 页面:使用颜色球
    if (isCustomizePage()) {
      const customSwatches = document.querySelectorAll(`.color-swatch[data-index="${optionIndex}"]`);
      console.log(`🔧 [EasyGo] Customize页面查找选项${optionIndex},找到${customSwatches.length}个颜色球`);

      if (customSwatches.length > 0) {
        const selectedSwatch = [...customSwatches].find(swatch =>
          swatch.classList.contains('selected')
        );

        if (selectedSwatch) {
          const colorName = selectedSwatch.dataset.value;
          console.log(`✅ [EasyGo] 选项${optionIndex}选中:`, colorName);
          return colorName;
        }
      }

      return null;
    }

    // 产品页面：优先检测 Globo 插件选择器
    // Globo 使用 globo-option-0, globo-option-1, globo-option-2 (从0开始)
    const globoInput = document.querySelector(`input[name="globo-option-${optionIndex}"]:checked`);
    if (globoInput) {
      const colorName = globoInput.value;
      console.log(`✅ [EasyGo] 选项${optionIndex}选中(Globo):`, colorName);
      return colorName;
    }

    // 如果没有 Globo，使用标准 Shopify 选择器
    // Shopify 选项编号从 1 开始，所以加 1
    const optionNumber = optionIndex + 1;
    const colorInputs = document.querySelectorAll(
      `input[name*="-${optionNumber}-option"]:checked, input[name*="-option-${optionNumber}"]:checked`
    );

    if (colorInputs.length > 0) {
      const colorInput = colorInputs[0];
      const colorName = colorInput.value;
      console.log(`✅ [EasyGo] 选项${optionIndex}选中(Shopify):`, colorName);
      return colorName;
    }

    return null;
  }

  // 获取当前选中的 variant 数据（仅 Customize 页面）
  function getCurrentVariant() {
    if (!isCustomizePage()) return null;

    // 从全局变量中获取当前 variant
    if (window.currentEasyGoVariant) {
      return window.currentEasyGoVariant;
    }

    return null;
  }

  // 检查是否需要强制使用 CDN 图片
  function shouldForceCDN(bodyColor, strapColor) {
    const body = normalizeColorName(bodyColor);
    const strap = normalizeColorName(strapColor);

    return FORCE_CDN_COMBINATIONS.some(combo =>
      combo.body === body && combo.strap === strap
    );
  }

  // 更新产品图片（带防抖）
  function updateProductImage() {
    // 🎯 防抖：取消之前的更新请求
    if (updateTimer) {
      clearTimeout(updateTimer);
      console.log('⏭️  [EasyGo] 取消之前的更新请求');
    }

    // 延迟执行，等待 DOM 更新和 Shopify 原生更新完成
    updateTimer = setTimeout(function() {
      doUpdateProductImage();
    }, 600); // 600ms 延迟，确保 Shopify 的更新先完成
  }

  // 获取选项索引映射 (根据标签名称)
  // Customize 页面只从 #product-option-groups 内的 .color-swatches 前的 label 判断，避免误用其他 label
  function getOptionIndices() {
    const indices = {
      handle: 0,
      body: 1,
      strap: 2
    };

    if (isCustomizePage()) {
      const groups = document.querySelectorAll('#product-option-groups .color-swatches');
      groups.forEach((group, index) => {
        const label = group.previousElementSibling;
        if (label && label.tagName === 'LABEL') {
          const text = label.textContent.toLowerCase();
          if (text.includes('handle')) indices.handle = index;
          else if (text.includes('body')) indices.body = index;
          else if (text.includes('strap') || text.includes('leash')) indices.strap = index;
        }
      });
      console.log('🔧 [EasyGo] Customize 选项索引:', indices);
      return indices;
    }

    // 产品页：尝试根据标签文本动态查找
    const labels = document.querySelectorAll('label, .product-form__label, .form__label');
    labels.forEach((label, index) => {
      const text = label.textContent.toLowerCase();
      if (text.includes('handle')) indices.handle = index;
      else if (text.includes('body')) indices.body = index;
      else if (text.includes('strap') || text.includes('leash')) indices.strap = index;
    });
    return indices;
  }

  // 实际执行图片更新的函数
  function doUpdateProductImage() {
    console.log('🔧 [EasyGo] 开始更新产品图片...');

    // ⚠️ 重要：再次确认是否应该运行
    if (!shouldRun()) {
      console.log('⏭️  [EasyGo] 不是 EasyGo 产品，跳过更新');
      return;
    }

    // 获取三个属性的当前值：按选项名称映射索引，避免 API 选项顺序与 Handle/Body/Strap 不一致
    const indices = getOptionIndices();
    const handleColor = getCurrentColor(indices.handle);
    const bodyColor = getCurrentColor(indices.body);
    const strapColor = getCurrentColor(indices.strap);

    console.log('🔧 [EasyGo] 当前选择:', {
      handleColor,
      bodyColor,
      strapColor
    });

    // 🎯 先检查是否需要强制使用 CDN 图片
    const forceCDN = shouldForceCDN(bodyColor, strapColor);
    
    // 如果不是强制 CDN 组合
    if (!forceCDN) {
      console.log('⏭️  [EasyGo] 不是强制 CDN 组合 (Body: ' + bodyColor + ', Strap: ' + strapColor + ')');
      
      // 🛡️  停止保护 CDN 图片
      stopProtectingCDNImage();
      
      // 👀 同时停止监听主图容器
      stopObserveGallery();
      
      // 🎯 如果之前锁定了图片，现在解锁
      const lockedImages = document.querySelectorAll('img[data-easygo-locked="true"]');
      if (lockedImages.length > 0) {
        console.log(`🔓 [EasyGo] 解锁 ${lockedImages.length} 个图片`);
        lockedImages.forEach(img => {
          img.removeAttribute('data-easygo-locked');
          img.removeAttribute('data-easygo-src');
        });
      }
      
      // 🎯 关键修复：在 Customize 页面，我们需要手动切换回 Variant 图片
      // 因为我们在 product-custom-builder.liquid 里禁用了原生更新
      if (isCustomizePage()) {
        console.log('🔧 [EasyGo] Customize页面：手动切换回 Variant 图片');
        const currentVariant = getCurrentVariant();
        
        if (currentVariant && currentVariant.featured_image) {
          const variantImage = currentVariant.featured_image.src;
          console.log('✅ [EasyGo] 找到 Variant 图片:', variantImage);
          
          const img = document.querySelector('.custom-builder .main-image') ||
                      document.querySelector('#product-link .main-image') ||
                      document.querySelector('.product-image .main-image');
          if (img) {
            // 移除 srcset 防止干扰
            if (img.hasAttribute('srcset')) img.removeAttribute('srcset');
            if (img.hasAttribute('sizes')) img.removeAttribute('sizes');
            
            img.src = variantImage;
          }
        } else {
          console.log('⚠️ [EasyGo] 未找到 Variant 图片或当前无 Variant');
        }
      } else {
        console.log('⏭️  [EasyGo] 产品页面：让 Shopify 原生逻辑处理图片');
      }
      
      return;
    }
    
    console.log('✅ [EasyGo] 检测到强制 CDN 组合 (Body: ' + bodyColor + ', Strap: ' + strapColor + ')');
    
    // 👀 开始监听主图容器，一旦主题替换主图 DOM，我们就再覆盖一次
    startObserveGallery();
    
    // 只有强制 CDN 组合才继续执行
    if (handleColor && bodyColor && strapColor) {
      // 🔄 查找所有可能的主图片元素（可能有多个）
      let mainImages = [];

      if (isCustomizePage()) {
        const customSelectors = [
          '.custom-builder .main-image',
          '#product-link .main-image',
          '.product-image .main-image',
          '.custom-builder img.main-image'
        ];
        for (const sel of customSelectors) {
          const img = document.querySelector(sel);
          if (img) {
            mainImages.push(img);
            console.log('✅ [EasyGo] Customize 找到主图:', sel);
            break;
          }
        }
      } else {
        // 产品页面:查找主图片
        const selectors = [
          '.product-single__photo img',
          '.product__media-item img',
          '.product-image img',
          'img.theme-img',
          '.product__media img',
          '.product-gallery img',
          '[data-product-featured-image]',
          '.product__main-photos img',
          '#ProductPhotoImg',
          '.featured-image img'
        ];
        
        // 🎯 策略1: 优先查找有特定类名的图片（active/current/selected）
        // 在 Slider 中，通常通过类名来标识当前显示的图片
        for (const selector of selectors) {
          const images = document.querySelectorAll(selector);
          for (const img of images) {
            // 检查图片本身或其各级父元素的类名
            let element = img;
            let hasActiveClass = false;
            
            // 向上检查 3 层父元素
            for (let i = 0; i < 3 && element; i++) {
              if (element.classList && (
                element.classList.contains('active') || 
                element.classList.contains('current') ||
                element.classList.contains('selected') ||
                element.classList.contains('is-selected') ||
                element.classList.contains('is-active') ||
                element.classList.contains('slick-current') ||
                element.classList.contains('swiper-slide-active')
              )) {
                hasActiveClass = true;
                break;
              }
              element = element.parentElement;
            }
            
            if (hasActiveClass && !mainImages.includes(img)) {
              const rect = img.getBoundingClientRect();
              const isLargeEnough = rect.width > 200 && rect.height > 200;
              const isVisible = window.getComputedStyle(img).opacity !== '0' && 
                               window.getComputedStyle(img).visibility !== 'hidden' &&
                               window.getComputedStyle(img).display !== 'none';
              
              if (isLargeEnough && isVisible) {
                mainImages.push(img);
                console.log(`✅ [EasyGo] 找到 active 主图片: ${selector}, 尺寸: ${Math.round(rect.width)}x${Math.round(rect.height)}`);
              } else {
                console.log(`⚠️  [EasyGo] 跳过 active 图片（不可见或太小）: ${selector}`);
              }
            }
          }
        }
        
        // 🎯 策略2: 如果没找到 active 图片，使用 CSS 可见性判断（适用于 Slider）
        if (mainImages.length === 0) {
          console.log('⚠️  [EasyGo] 未找到 active 图片，使用 CSS 可见性查找（Slider模式）');
          
          let bestCandidate = null;
          let bestScore = -1;
          
          for (const selector of selectors) {
            const images = document.querySelectorAll(selector);
            console.log(`🔍 [EasyGo] 选择器 ${selector} 找到 ${images.length} 个图片元素`);
            
            for (const img of images) {
              const rect = img.getBoundingClientRect();
              const style = window.getComputedStyle(img);
              
              // 基本条件：尺寸足够大
              if (rect.width < 200 || rect.height < 200) continue;
              
              // CSS 可见性检查
              const opacity = parseFloat(style.opacity);
              const visibility = style.visibility;
              const display = style.display;
              const zIndex = parseInt(style.zIndex) || 0;
              
              // 计算可见性得分
              let score = 0;
              if (opacity > 0.5) score += 100;
              if (visibility === 'visible') score += 50;
              if (display !== 'none') score += 50;
              score += zIndex; // z-index 越高越好
              
              // 🎯 关键：图片中心点必须在视口内，否则不考虑
              const centerX = rect.x + rect.width / 2;
              const centerY = rect.y + rect.height / 2;
              const inViewportX = centerX >= 0 && centerX <= window.innerWidth;
              const inViewportY = centerY >= 0 && centerY <= window.innerHeight;
              
              if (inViewportX && inViewportY) {
                score += 500; // 大幅加分，确保优先选择视口内的图片
                console.log(`🎯 [EasyGo] 图片中心在视口内！center: (${Math.round(centerX)}, ${Math.round(centerY)})`);
              } else {
                // 如果不在视口内，基本不考虑
                score = 0;
              }
              
              console.log(`🔍 [EasyGo] 图片评分: ${score} (opacity:${opacity.toFixed(2)}, vis:${visibility}, z:${zIndex}, y:${Math.round(rect.y)})`);
              
              if (score > bestScore) {
                bestScore = score;
                bestCandidate = img;
              }
            }
            
            // 如果找到了高分候选，使用它
            if (bestCandidate && bestScore > 150) {
              mainImages.push(bestCandidate);
              console.log(`✅ [EasyGo] 选择最佳候选图片，得分: ${bestScore}`);
              break;
            }
          }
          
          // 如果还是没找到，报告原因
          if (mainImages.length === 0) {
            console.error('❌ [EasyGo] 所有图片得分都太低，无法确定主图');
            console.log('💡 [EasyGo] 最佳候选得分:', bestScore);
          }
        }
      }

      // 🎯 如果找到了图片，选择第一个作为主图片（不再更新所有）
      let mainImage = null;
      if (mainImages.length > 0) {
        // 🎯 关键改变：只使用第一个图片，不更新所有
        mainImage = mainImages[0];
        console.log(`✅ [EasyGo] 找到 ${mainImages.length} 个图片，只更新第一个（主图）`);
      }

      if (!mainImage || mainImages.length === 0) {
        console.warn('⚠️  [EasyGo] 策略1/2未找到图片，尝试策略3：从视口中心查找实际可见的图片');
        
        // 🎯 策略3：使用 elementFromPoint 找到视口中实际显示的图片
        // 在视口左侧1/3位置（产品图通常在左边）
        const viewportX = window.innerWidth / 3;
        const viewportY = window.innerHeight / 2;
        
        console.log(`🔍 [EasyGo] 在视口位置 (${Math.round(viewportX)}, ${Math.round(viewportY)}) 查找元素`);
        
        // 尝试暂时隐藏可能的遮罩层，以便点到下面的图片
        let element = document.elementFromPoint(viewportX, viewportY);
        
        // 辅助函数：检查元素是否覆盖了目标点
        const coversPoint = (el, x, y) => {
          const rect = el.getBoundingClientRect();
          return x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom;
        };
        
        let attempts = 0;
        // 从点击的元素向上查找
        while (element && attempts < 5) {
          console.log(`🔍 [EasyGo] 检查元素: <${element.tagName}> class="${element.className}"`);
          
          // 1. 如果元素本身是图片，且覆盖目标点
          if (element.tagName === 'IMG' && coversPoint(element, viewportX, viewportY)) {
            console.log('✅ [EasyGo] elementFromPoint 直接找到了图片！');
            mainImage = element;
            break;
          }
          
          // 2. 查找该元素内部的所有图片，找到真正覆盖目标点的那一个
          const imagesInside = element.querySelectorAll('img');
          if (imagesInside.length > 0) {
            console.log(`🔍 [EasyGo] 容器内有 ${imagesInside.length} 个图片，寻找覆盖目标点的那个...`);
            for (const img of imagesInside) {
              if (coversPoint(img, viewportX, viewportY)) {
                // 确保图片可见
                const style = window.getComputedStyle(img);
                if (style.opacity !== '0' && style.visibility !== 'hidden' && style.display !== 'none') {
                  console.log(`✅ [EasyGo] 在容器内找到了目标图片！尺寸: ${img.offsetWidth}x${img.offsetHeight}`);
                  mainImage = img;
                  break;
                }
              }
            }
            if (mainImage) break;
          }
          
          // 3. 如果没找到，尝试父元素（有时候 elementFromPoint 点到的是图片内部的装饰层）
          element = element.parentElement;
          attempts++;
        }
        
        if (!mainImage) {
          console.warn('⚠️ [EasyGo] 策略1/2/3都失败了，尝试策略4：寻找视口内可视面积最大的图片');
          
          let maxVisibleArea = 0;
          let bestImage = null;
          
          // 查找页面上所有的图片
          const allImages = document.querySelectorAll('img');
          const viewportWidth = window.innerWidth;
          const viewportHeight = window.innerHeight;
          
          console.log(`🔍 [EasyGo] 正在计算 ${allImages.length} 张图片的可视面积...`);
          
          allImages.forEach(img => {
            // 快速过滤小图标
            if (img.width < 200 || img.height < 200) return;
            
            const rect = img.getBoundingClientRect();
            
            // 计算与视口的交叉区域（可视区域）
            const intersectionLeft = Math.max(0, rect.left);
            const intersectionTop = Math.max(0, rect.top);
            const intersectionRight = Math.min(viewportWidth, rect.right);
            const intersectionBottom = Math.min(viewportHeight, rect.bottom);
            
            if (intersectionRight > intersectionLeft && intersectionBottom > intersectionTop) {
              const visibleWidth = intersectionRight - intersectionLeft;
              const visibleHeight = intersectionBottom - intersectionTop;
              const visibleArea = visibleWidth * visibleHeight;
              
              // 必须是真正可见的（没有被隐藏）
              const style = window.getComputedStyle(img);
              if (style.opacity !== '0' && style.visibility !== 'hidden' && style.display !== 'none') {
                if (visibleArea > maxVisibleArea) {
                  maxVisibleArea = visibleArea;
                  bestImage = img;
                  // console.log(`Candidate: 面积=${visibleArea}, src=${img.src.substring(0,30)}...`);
                }
              }
            }
          });
          
          if (bestImage) {
             console.log(`✅ [EasyGo] 策略4成功！找到可视面积最大的图片 (${Math.round(maxVisibleArea)}px²)`);
             mainImage = bestImage;
          } else {
             console.error('❌ [EasyGo] 策略4也失败了，屏幕上似乎没有大图片？');
          }
        }

        if (!mainImage) {
          console.error('❌ [EasyGo] 所有策略都失败了，无法找到主图片');
          return;
        }
      }
      
      // 🔍 调试：显示找到的图片信息
      const rect = mainImage.getBoundingClientRect();
      console.log('🔍 [EasyGo] 主图片详细信息:');
      console.log(`  id: ${mainImage.id || 'none'}, class: ${mainImage.className}`);
      console.log(`  位置: x:${Math.round(rect.x)} y:${Math.round(rect.y)}, 尺寸: ${Math.round(rect.width)}x${Math.round(rect.height)}`);

      // 强制 CDN 组合：从 CDN 加载图片
      console.log('🔧 [EasyGo] 开始从 CDN 加载图片...');
      
      const cdnImageUrl = generateImageUrl(handleColor, bodyColor, strapColor);
      if (cdnImageUrl) {
        // 先测试 CDN 图片是否存在
        testImageExists(cdnImageUrl, function(exists) {
          if (exists) {
            console.log('✅ [EasyGo] CDN 图片存在，更新主图片');
            // 🎯 只更新主图片（第一个），不更新所有
            updateImageSrc(mainImage, cdnImageUrl);
          } else {
            console.error('❌ [EasyGo] CDN 图片不存在:', cdnImageUrl);
            showImageError('This color combination image is not available yet');
          }
        });
      } else {
        // 生成URL失败（颜色组合未上传）
        console.error('❌ [EasyGo] 无法生成图片URL（颜色组合未上传到CDN）');
        showImageError('This color combination image is not available yet. Please contact support.');
      }
    } else {
      console.log('⏭️  [EasyGo] 属性未全部选择,等待用户完成选择');
    }
  }

  // 获取主图容器（不同主题可以再加 selector）
  function getGalleryContainer() {
    // 如果是 Customize 页面，直接返回特定的容器
    if (isCustomizePage()) {
      const customContainer = document.querySelector('.custom-builder .product-image');
      if (customContainer) {
        console.log('✅ [EasyGo] 找到 Customize 页面主图容器');
        return customContainer;
      }
    }

    const selectors = [
      '.product__media-wrapper',
      '.product__media-list',
      '.product-gallery',
      '.product__main-photos',
      '.product-single__photos',
      '.product__media',
      '.product-single__photo',
      '.product-photos',
      '.product-images',
      '[data-product-images]',
      '[data-product-photos]',
      '#ProductPhotos',
      '#ProductImages'
    ];
    
    for (const selector of selectors) {
      const el = document.querySelector(selector);
      if (el) {
        console.log('✅ [EasyGo] 找到主图容器:', selector);
        return el;
      }
    }
    
    // 🎯 备用策略：找任何包含主图片的父容器
    const mainImage = document.querySelector('img.theme-img, .product-single__photo img, .product__media-item img');
    if (mainImage) {
      // 找它的3层父元素作为容器
      let container = mainImage.parentElement;
      for (let i = 0; i < 3 && container; i++) {
        if (container.children.length > 1) {
          console.log('✅ [EasyGo] 使用备用策略找到主图容器:', container.className || container.id);
          return container;
        }
        container = container.parentElement;
      }
    }
    
    return null;
  }

  // 开始监听主图容器的 DOM 变化
  function startObserveGallery() {
    if (galleryObserver) return; // 已经在监听就不要重复开

    const container = getGalleryContainer();
    if (!container) {
      console.log('⚠️  [EasyGo] 未找到主图容器, 无法监听 DOM 变化');
      return;
    }

    galleryObserver = new MutationObserver(function(mutations) {
      for (const mutation of mutations) {
        if (mutation.type === 'childList') {
          console.log('👀 [EasyGo] 检测到主图 DOM 结构变化, 再次尝试覆盖 CDN 图片');
          // 这里再次调用带防抖的更新逻辑
          updateProductImage();
          break;
        }
      }
    });

    galleryObserver.observe(container, {
      childList: true,
      subtree: true
    });

    console.log('👀 [EasyGo] 已开始监听主图容器 DOM 变化');
  }

  // 停止监听主图容器
  function stopObserveGallery() {
    if (galleryObserver) {
      galleryObserver.disconnect();
      galleryObserver = null;
      console.log('🛑 [EasyGo] 已停止监听主图容器');
    }
  }

  // 测试图片是否存在
  function testImageExists(url, callback) {
    const img = new Image();
    img.onload = function() {
      callback(true);
    };
    img.onerror = function() {
      callback(false);
    };
    img.src = url;
  }

  // 🎯 保护 CDN 图片不被 Shopify 覆盖
  let cdnImageObserver = null;
  
  function protectCDNImage(imgElement, cdnSrc) {
    // 如果已经有 observer，先断开
    if (cdnImageObserver) {
      cdnImageObserver.disconnect();
    }
    
    // 创建新的 MutationObserver 监听图片变化
    cdnImageObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes') {
          const attrName = mutation.attributeName;
          
          // 如果 src 被改变，且不是我们的 CDN 地址，立即还原
          if (attrName === 'src' && imgElement.src !== cdnSrc) {
            console.log('🛡️  [EasyGo] 检测到 src 被修改，立即还原 CDN 图片');
            imgElement.src = cdnSrc;
          }
          
          // 如果 srcset 被重新添加，立即移除
          if (attrName === 'srcset' && imgElement.hasAttribute('srcset')) {
            console.log('🛡️  [EasyGo] 检测到 srcset 被重新添加，立即移除');
            imgElement.removeAttribute('srcset');
          }
          
          // 如果 sizes 被重新添加，立即移除
          if (attrName === 'sizes' && imgElement.hasAttribute('sizes')) {
            console.log('🛡️  [EasyGo] 检测到 sizes 被重新添加，立即移除');
            imgElement.removeAttribute('sizes');
          }
        }
      });
    });
    
    // 开始监听
    cdnImageObserver.observe(imgElement, {
      attributes: true,
      attributeFilter: ['src', 'srcset', 'sizes']
    });
    
    console.log('🛡️  [EasyGo] 已启动 CDN 图片保护');
  }
  
  function stopProtectingCDNImage() {
    if (cdnImageObserver) {
      cdnImageObserver.disconnect();
      cdnImageObserver = null;
      console.log('🛡️  [EasyGo] 已停止 CDN 图片保护');
    }
  }

  // 更新图片 src（带动画）
  function updateImageSrc(imgElement, newSrc) {
    console.log('🔧 [EasyGo] updateImageSrc 被调用');
    console.log('  图片元素:', imgElement);
    console.log('  当前 src:', imgElement.src);
    console.log('  新 src:', newSrc);
    console.log('  图片可见:', imgElement.offsetWidth > 0 && imgElement.offsetHeight > 0);
    console.log('  图片尺寸:', imgElement.offsetWidth, 'x', imgElement.offsetHeight);
    console.log('  有 srcset:', imgElement.hasAttribute('srcset'));
    
    // 如果图片已经是当前的，跳过
    if (imgElement.src === newSrc) {
      console.log('⏭️  [EasyGo] 图片未变化，跳过更新');
      return;
    }

    // 预加载新图片
    const newImage = new Image();
    newImage.onload = function() {
      console.log('✅ [EasyGo] 新图片预加载成功');
      
      // 添加淡入动画
      imgElement.style.transition = 'opacity 0.3s ease';
      imgElement.style.opacity = '0.5';

      setTimeout(() => {
        const oldSrc = imgElement.src;
        
        // 🎯 关键修复：移除 srcset 属性，防止响应式图片系统干扰
        if (imgElement.hasAttribute('srcset')) {
          console.log('🔧 [EasyGo] 移除 srcset 属性');
          imgElement.removeAttribute('srcset');
        }
        
        // 同时移除 sizes 属性
        if (imgElement.hasAttribute('sizes')) {
          console.log('🔧 [EasyGo] 移除 sizes 属性');
          imgElement.removeAttribute('sizes');
        }
        
        // 🎯 处理懒加载
        if (imgElement.loading === 'lazy') {
          console.log('🔧 [EasyGo] 禁用懒加载');
          imgElement.loading = 'eager';
        }
        
        // 移除 data-src 等懒加载属性
        if (imgElement.hasAttribute('data-src')) {
          imgElement.removeAttribute('data-src');
        }
        if (imgElement.hasAttribute('data-srcset')) {
          imgElement.removeAttribute('data-srcset');
        }
        
        // 更新 src
        imgElement.src = newSrc;
        
        // 🎯 强制浏览器重新加载图片
        // 添加一个时间戳参数强制刷新（如果URL已经有参数）
        if (!imgElement.complete) {
          imgElement.src = imgElement.src; // 触发重新加载
        }
        
        // 确保图片完全不透明
        imgElement.style.opacity = '1';
        
        // 🎯 强制浏览器重绘
        imgElement.style.display = 'none';
        imgElement.offsetHeight; // 触发重排
        imgElement.style.display = '';
        
        console.log('✅ [EasyGo] 图片已更新');
        console.log('  旧 src:', oldSrc);
        console.log('  新 src:', imgElement.src);
        console.log('  srcset 已移除:', !imgElement.hasAttribute('srcset'));
        console.log('  图片完整加载:', imgElement.complete);
        
        // 🎯 标记这个图片元素，防止其他脚本修改
        imgElement.setAttribute('data-easygo-locked', 'true');
        imgElement.setAttribute('data-easygo-src', newSrc);
        
        // 🛡️  启动保护机制，防止 Shopify 覆盖 CDN 图片
        protectCDNImage(imgElement, newSrc);
        
        // 验证图片是否真的更新了（多次验证）
        setTimeout(() => {
          const currentSrc = imgElement.src;
          if (currentSrc === newSrc) {
            console.log('✅ [EasyGo] 验证：图片 src 确实已更新');
            console.log('✅ [EasyGo] 图片应该可见了！');
          } else {
            console.error('❌ [EasyGo] 验证失败：图片 src 被还原了', currentSrc);
            console.log('🔧 [EasyGo] 尝试重新更新...');
            // 重新更新
            imgElement.removeAttribute('srcset');
            imgElement.removeAttribute('sizes');
            imgElement.src = newSrc;
          }
        }, 500);
        
        // 再次验证（1秒后）
        setTimeout(() => {
          const currentSrc = imgElement.src;
          if (currentSrc !== newSrc) {
            console.error('❌ [EasyGo] 2次验证失败：图片仍然被还原', currentSrc);
            // 最后一次尝试
            imgElement.src = newSrc;
          } else {
            console.log('✅ [EasyGo] 2次验证通过：图片稳定');
          }
        }, 1000);
      }, 150);
    };

    newImage.onerror = function() {
      console.error('❌ [EasyGo] 图片预加载失败:', newSrc);
    };

    console.log('🔧 [EasyGo] 开始预加载新图片...');
    newImage.src = newSrc;
  }

  // 显示图片错误提示
  function showImageError(message) {
    let errorOverlay = document.getElementById('easygo-error-overlay');

    if (!errorOverlay) {
      errorOverlay = document.createElement('div');
      errorOverlay.id = 'easygo-error-overlay';
      errorOverlay.style.cssText = `
        position: fixed;
        top: 20px;
        right: 20px;
        background: rgba(220, 38, 38, 0.95);
        color: white;
        padding: 16px 24px;
        border-radius: 8px;
        font-size: 14px;
        font-weight: 600;
        z-index: 10000;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
        animation: slideInRight 0.3s ease-out;
      `;

      const style = document.createElement('style');
      style.textContent = `
        @keyframes slideInRight {
          from {
            transform: translateX(100%);
            opacity: 0;
          }
          to {
            transform: translateX(0);
            opacity: 1;
          }
        }
      `;
      document.head.appendChild(style);

      document.body.appendChild(errorOverlay);
    }

    errorOverlay.textContent = message;
    errorOverlay.style.display = 'block';

    setTimeout(() => {
      errorOverlay.style.display = 'none';
    }, 3000);
  }

  // 绑定颜色选择器事件
  let hasLoggedSkipBinding = false;
  function bindColorSelectors() {
    // ⚠️ 再次确认是否应该运行
    if (!shouldRun()) {
      // 🎯 只在第一次时输出日志，避免重复
      if (!hasLoggedSkipBinding) {
        console.log('⏭️  [EasyGo] 不是 EasyGo 产品，跳过绑定');
        hasLoggedSkipBinding = true;
      }
      return;
    }
    // 如果是目标产品，重置标记
    hasLoggedSkipBinding = false;

    console.log('🔧 [EasyGo] 开始绑定颜色选择器...');

    // Customize 页面:绑定颜色球
    if (isCustomizePage()) {
      const customSwatches = document.querySelectorAll('.color-swatch');
      console.log(`🔧 [EasyGo] 找到 ${customSwatches.length} 个颜色球`);

      customSwatches.forEach((swatch, index) => {
        // 避免重复绑定
        if (swatch.dataset.easygobound === 'true') return;
        swatch.dataset.easygobound = 'true';

        swatch.addEventListener('click', function() {
          console.log('🎨 [EasyGo] 颜色球点击:', this.dataset.value);
          // 立即调用（防抖已在 updateProductImage 中处理）
          updateProductImage();
        });

        console.log(`✅ [EasyGo] 已绑定颜色球[${index}]:`, swatch.dataset.value);
      });
    } else {
      // 产品页面:绑定 input
      const colorInputs = document.querySelectorAll('input[type="radio"]');
      console.log(`🔧 [EasyGo] 找到 ${colorInputs.length} 个 radio input`);

      colorInputs.forEach((input, index) => {
        // 避免重复绑定
        if (input.dataset.easygobound === 'true') return;
        input.dataset.easygobound = 'true';

        input.addEventListener('change', function() {
          if (this.checked) {
            console.log('🎨 [EasyGo] Input变化:', this.value);
            // 立即调用（防抖已在 updateProductImage 中处理）
            updateProductImage();
          }
        });

        console.log(`✅ [EasyGo] 已绑定input[${index}]:`, input.id);
      });
    }

    console.log('✅ [EasyGo] 颜色选择器绑定完成');
  }

  // 初始化
  function init() {
    if (!shouldRun()) {
      console.log('⏭️  [EasyGo] 不是目标产品,跳过初始化');
      return;
    }

    console.log('✅ [EasyGo] 开始初始化...');

    // 绑定颜色选择器
    bindColorSelectors();

    // 如果首次没找到选择器,每2秒重新检查
    let recheckCount = 0;
    const recheckInterval = setInterval(() => {
      // 🎯 先检查是否应该运行，如果不是目标产品就直接跳过，避免重复日志
      if (!shouldRun()) {
        recheckCount++;
        // 如果不是目标产品，直接停止定时器
        if (recheckCount >= 5) {
          clearInterval(recheckInterval);
        }
        return;
      }
      
      const swatches = document.querySelectorAll('.color-swatch, input[type="radio"]');

      if (swatches.length > 0) {
        bindColorSelectors();
      }

      recheckCount++;

      // 10次后停止重复检查(20秒)
      if (recheckCount >= 10) {
        clearInterval(recheckInterval);
        console.log('⚠️  [EasyGo] 达到最大重试次数,停止检查');
      }
    }, 2000);

    // 监听产品切换(Customize 页面)
    if (isCustomizePage()) {
      const productSelect = document.getElementById('product-select');
      if (productSelect && !productSelect.dataset.easygoBound) {
        productSelect.dataset.easygoBound = 'true';

        productSelect.addEventListener('change', function() {
          const selectedOption = this.options[this.selectedIndex];
          const productName = selectedOption ? selectedOption.textContent.trim() : '';
          console.log('🔄 [EasyGo] 产品切换:', productName);
          
          // 🎯 切换产品时，重置日志标记，允许输出新的日志
          hasLoggedMismatch = false;
          hasLoggedSkipBinding = false;
          lastCheckedProduct = '';
          
          // 切换时，先重置所有绑定状态
          document.querySelectorAll('[data-easygobound="true"]').forEach(el => {
             el.dataset.easygobound = 'false';
          });
        });
      }
      
      // 🎯 新增：监听选项容器变化 (MutationObserver)
      // 这是解决动态加载导致绑定失效的关键
      const optionsWrapper = document.getElementById('product-option-groups');
      if (optionsWrapper) {
        console.log('👀 [EasyGo] 启动 Customize 页面选项区域监听');
        const optionsObserver = new MutationObserver(function(mutations) {
          // 检查是否有新节点添加
          const hasNewNodes = mutations.some(m => m.addedNodes.length > 0);
          if (hasNewNodes) {
            console.log('👀 [EasyGo] 检测到选项区域更新，重新初始化...');
            
            // 给予一点缓冲时间让 DOM 稳定
            setTimeout(() => {
              if (shouldRun()) {
                 // 清除旧标记，强制重新绑定
                 document.querySelectorAll('.color-swatch').forEach(el => {
                   el.removeAttribute('data-easygobound');
                 });
                 init();
              }
            }, 300);
          }
        });
        
        optionsObserver.observe(optionsWrapper, {
          childList: true,
          subtree: true
        });
      }
    }

    console.log('✅ [EasyGo] 初始化完成');
  }

  // 延迟初始化
  function delayedInit() {
    const delay = isCustomizePage() ? 2000 : 500;
    setTimeout(() => {
      if (shouldRun()) {
        init();
      } else if (isCustomizePage()) {
        // Customize 页面再等一次
        setTimeout(() => {
          if (shouldRun()) init();
        }, 2000);
      }
    }, delay);
  }

  // 启动脚本
  if (isCustomizePage() || shouldRun()) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', delayedInit);
    } else {
      delayedInit();
    }
  }

  // 暴露全局函数供调试
  window.EasyGoCarrier = {
    updateImage: updateProductImage,
    getCurrentColor: getCurrentColor,
    generateUrl: generateImageUrl,
    reinit: init,
    test: function(handle, body, strap) {
      console.log('🧪 [TEST] 测试图片URL生成...');
      const url = generateImageUrl(handle, body, strap);
      console.log('URL:', url);
      return url;
    }
  };

  console.log('🎨 EasyGo Pet Carrier 图片系统已加载!');
  console.log('💡 调试命令:');
  console.log('   EasyGoCarrier.updateImage() - 手动更新图片');
  console.log('   EasyGoCarrier.test("Cyan", "Pink", "White") - 测试URL生成');
  console.log('   EasyGoCarrier.getCurrentColor(0) - 查看选项0的当前值');
})();
